var map = {
	"./12e49.png": "./src/assets/itemIcons/12e49.png",
	"./12eb7.png": "./src/assets/itemIcons/12eb7.png",
	"./1359d.png": "./src/assets/itemIcons/1359d.png",
	"./135ba.png": "./src/assets/itemIcons/135ba.png",
	"./13790.png": "./src/assets/itemIcons/13790.png",
	"./13910.png": "./src/assets/itemIcons/13910.png",
	"./13912.png": "./src/assets/itemIcons/13912.png",
	"./13914.png": "./src/assets/itemIcons/13914.png",
	"./1391e.png": "./src/assets/itemIcons/1391e.png",
	"./13921.png": "./src/assets/itemIcons/13921.png",
	"./13938.png": "./src/assets/itemIcons/13938.png",
	"./13939.png": "./src/assets/itemIcons/13939.png",
	"./1393a.png": "./src/assets/itemIcons/1393a.png",
	"./1393c.png": "./src/assets/itemIcons/1393c.png",
	"./13946.png": "./src/assets/itemIcons/13946.png",
	"./13948.png": "./src/assets/itemIcons/13948.png",
	"./1394b.png": "./src/assets/itemIcons/1394b.png",
	"./1394c.png": "./src/assets/itemIcons/1394c.png",
	"./1394d.png": "./src/assets/itemIcons/1394d.png",
	"./1394e.png": "./src/assets/itemIcons/1394e.png",
	"./1394f.png": "./src/assets/itemIcons/1394f.png",
	"./13950.png": "./src/assets/itemIcons/13950.png",
	"./13951.png": "./src/assets/itemIcons/13951.png",
	"./13953.png": "./src/assets/itemIcons/13953.png",
	"./13954.png": "./src/assets/itemIcons/13954.png",
	"./13955.png": "./src/assets/itemIcons/13955.png",
	"./13956.png": "./src/assets/itemIcons/13956.png",
	"./13957.png": "./src/assets/itemIcons/13957.png",
	"./13958.png": "./src/assets/itemIcons/13958.png",
	"./1395c.png": "./src/assets/itemIcons/1395c.png",
	"./1395d.png": "./src/assets/itemIcons/1395d.png",
	"./13961.png": "./src/assets/itemIcons/13961.png",
	"./1397d.png": "./src/assets/itemIcons/1397d.png",
	"./1397e.png": "./src/assets/itemIcons/1397e.png",
	"./1397f.png": "./src/assets/itemIcons/1397f.png",
	"./13980.png": "./src/assets/itemIcons/13980.png",
	"./13981.png": "./src/assets/itemIcons/13981.png",
	"./13982.png": "./src/assets/itemIcons/13982.png",
	"./13983.png": "./src/assets/itemIcons/13983.png",
	"./13984.png": "./src/assets/itemIcons/13984.png",
	"./13986.png": "./src/assets/itemIcons/13986.png",
	"./13987.png": "./src/assets/itemIcons/13987.png",
	"./13988.png": "./src/assets/itemIcons/13988.png",
	"./13989.png": "./src/assets/itemIcons/13989.png",
	"./1398a.png": "./src/assets/itemIcons/1398a.png",
	"./1398b.png": "./src/assets/itemIcons/1398b.png",
	"./1398c.png": "./src/assets/itemIcons/1398c.png",
	"./1398d.png": "./src/assets/itemIcons/1398d.png",
	"./1398e.png": "./src/assets/itemIcons/1398e.png",
	"./1398f.png": "./src/assets/itemIcons/1398f.png",
	"./13990.png": "./src/assets/itemIcons/13990.png",
	"./13991.png": "./src/assets/itemIcons/13991.png",
	"./13992.png": "./src/assets/itemIcons/13992.png",
	"./13993.png": "./src/assets/itemIcons/13993.png",
	"./13994.png": "./src/assets/itemIcons/13994.png",
	"./13995.png": "./src/assets/itemIcons/13995.png",
	"./13996.png": "./src/assets/itemIcons/13996.png",
	"./13997.png": "./src/assets/itemIcons/13997.png",
	"./13998.png": "./src/assets/itemIcons/13998.png",
	"./13999.png": "./src/assets/itemIcons/13999.png",
	"./1399a.png": "./src/assets/itemIcons/1399a.png",
	"./1399b.png": "./src/assets/itemIcons/1399b.png",
	"./1399c.png": "./src/assets/itemIcons/1399c.png",
	"./1399d.png": "./src/assets/itemIcons/1399d.png",
	"./1399e.png": "./src/assets/itemIcons/1399e.png",
	"./1399f.png": "./src/assets/itemIcons/1399f.png",
	"./139a0.png": "./src/assets/itemIcons/139a0.png",
	"./139a1.png": "./src/assets/itemIcons/139a1.png",
	"./139a2.png": "./src/assets/itemIcons/139a2.png",
	"./139a3.png": "./src/assets/itemIcons/139a3.png",
	"./139a4.png": "./src/assets/itemIcons/139a4.png",
	"./139a5.png": "./src/assets/itemIcons/139a5.png",
	"./139a6.png": "./src/assets/itemIcons/139a6.png",
	"./139a7.png": "./src/assets/itemIcons/139a7.png",
	"./139a8.png": "./src/assets/itemIcons/139a8.png",
	"./139a9.png": "./src/assets/itemIcons/139a9.png",
	"./139aa.png": "./src/assets/itemIcons/139aa.png",
	"./139ab.png": "./src/assets/itemIcons/139ab.png",
	"./139b9.png": "./src/assets/itemIcons/139b9.png",
	"./139bb.png": "./src/assets/itemIcons/139bb.png",
	"./139bc.png": "./src/assets/itemIcons/139bc.png",
	"./139bd.png": "./src/assets/itemIcons/139bd.png",
	"./139be.png": "./src/assets/itemIcons/139be.png",
	"./18388.png": "./src/assets/itemIcons/18388.png",
	"./1b39f.png": "./src/assets/itemIcons/1b39f.png",
	"./1b3a0.png": "./src/assets/itemIcons/1b3a0.png",
	"./1b3a2.png": "./src/assets/itemIcons/1b3a2.png",
	"./1cd8a_Dragonborn_esm.png": "./src/assets/itemIcons/1cd8a_Dragonborn_esm.png",
	"./1cd97_Dragonborn_esm.png": "./src/assets/itemIcons/1cd97_Dragonborn_esm.png",
	"./1cdad_Dragonborn_esm.png": "./src/assets/itemIcons/1cdad_Dragonborn_esm.png",
	"./1cdae_Dragonborn_esm.png": "./src/assets/itemIcons/1cdae_Dragonborn_esm.png",
	"./1cdaf_Dragonborn_esm.png": "./src/assets/itemIcons/1cdaf_Dragonborn_esm.png",
	"./1cdb0_Dragonborn_esm.png": "./src/assets/itemIcons/1cdb0_Dragonborn_esm.png",
	"./1cdb1_Dragonborn_esm.png": "./src/assets/itemIcons/1cdb1_Dragonborn_esm.png",
	"./1cdb2_Dragonborn_esm.png": "./src/assets/itemIcons/1cdb2_Dragonborn_esm.png",
	"./1cdb3_Dragonborn_esm.png": "./src/assets/itemIcons/1cdb3_Dragonborn_esm.png",
	"./1cf2b.png": "./src/assets/itemIcons/1cf2b.png",
	"./26232_Dragonborn_esm.png": "./src/assets/itemIcons/26232_Dragonborn_esm.png",
	"./26235_Dragonborn_esm.png": "./src/assets/itemIcons/26235_Dragonborn_esm.png",
	"./26236_Dragonborn_esm.png": "./src/assets/itemIcons/26236_Dragonborn_esm.png",
	"./2623b_Dragonborn_esm.png": "./src/assets/itemIcons/2623b_Dragonborn_esm.png",
	"./3619e.png": "./src/assets/itemIcons/3619e.png",
	"./3988e.png": "./src/assets/itemIcons/3988e.png",
	"./39899.png": "./src/assets/itemIcons/39899.png",
	"./3989a.png": "./src/assets/itemIcons/3989a.png",
	"./3989b.png": "./src/assets/itemIcons/3989b.png",
	"./398ab.png": "./src/assets/itemIcons/398ab.png",
	"./398ac.png": "./src/assets/itemIcons/398ac.png",
	"./398ad.png": "./src/assets/itemIcons/398ad.png",
	"./398ec.png": "./src/assets/itemIcons/398ec.png",
	"./398ed.png": "./src/assets/itemIcons/398ed.png",
	"./398ee.png": "./src/assets/itemIcons/398ee.png",
	"./398f1.png": "./src/assets/itemIcons/398f1.png",
	"./398f3.png": "./src/assets/itemIcons/398f3.png",
	"./398f4.png": "./src/assets/itemIcons/398f4.png",
	"./398f5.png": "./src/assets/itemIcons/398f5.png",
	"./398f6.png": "./src/assets/itemIcons/398f6.png",
	"./398fd.png": "./src/assets/itemIcons/398fd.png",
	"./39903.png": "./src/assets/itemIcons/39903.png",
	"./39904.png": "./src/assets/itemIcons/39904.png",
	"./39930.png": "./src/assets/itemIcons/39930.png",
	"./39945.png": "./src/assets/itemIcons/39945.png",
	"./39946.png": "./src/assets/itemIcons/39946.png",
	"./39948.png": "./src/assets/itemIcons/39948.png",
	"./39949.png": "./src/assets/itemIcons/39949.png",
	"./3994b.png": "./src/assets/itemIcons/3994b.png",
	"./3994e.png": "./src/assets/itemIcons/3994e.png",
	"./3994f.png": "./src/assets/itemIcons/3994f.png",
	"./39950.png": "./src/assets/itemIcons/39950.png",
	"./39951.png": "./src/assets/itemIcons/39951.png",
	"./39954.png": "./src/assets/itemIcons/39954.png",
	"./39955.png": "./src/assets/itemIcons/39955.png",
	"./39956.png": "./src/assets/itemIcons/39956.png",
	"./39957.png": "./src/assets/itemIcons/39957.png",
	"./39958.png": "./src/assets/itemIcons/39958.png",
	"./39959.png": "./src/assets/itemIcons/39959.png",
	"./3995a.png": "./src/assets/itemIcons/3995a.png",
	"./3995b.png": "./src/assets/itemIcons/3995b.png",
	"./3995c.png": "./src/assets/itemIcons/3995c.png",
	"./3995d.png": "./src/assets/itemIcons/3995d.png",
	"./39962.png": "./src/assets/itemIcons/39962.png",
	"./39967.png": "./src/assets/itemIcons/39967.png",
	"./39968.png": "./src/assets/itemIcons/39968.png",
	"./39969.png": "./src/assets/itemIcons/39969.png",
	"./3996f.png": "./src/assets/itemIcons/3996f.png",
	"./39970.png": "./src/assets/itemIcons/39970.png",
	"./39971.png": "./src/assets/itemIcons/39971.png",
	"./39973.png": "./src/assets/itemIcons/39973.png",
	"./39974.png": "./src/assets/itemIcons/39974.png",
	"./39980.png": "./src/assets/itemIcons/39980.png",
	"./39aa6.png": "./src/assets/itemIcons/39aa6.png",
	"./39b0c.png": "./src/assets/itemIcons/39b0c.png",
	"./39b4a.png": "./src/assets/itemIcons/39b4a.png",
	"./39b4b.png": "./src/assets/itemIcons/39b4b.png",
	"./39b8a.png": "./src/assets/itemIcons/39b8a.png",
	"./39bdf.png": "./src/assets/itemIcons/39bdf.png",
	"./39be1.png": "./src/assets/itemIcons/39be1.png",
	"./39be3.png": "./src/assets/itemIcons/39be3.png",
	"./39be4.png": "./src/assets/itemIcons/39be4.png",
	"./39be6.png": "./src/assets/itemIcons/39be6.png",
	"./39be8.png": "./src/assets/itemIcons/39be8.png",
	"./39cfb.png": "./src/assets/itemIcons/39cfb.png",
	"./39d02.png": "./src/assets/itemIcons/39d02.png",
	"./39d0a.png": "./src/assets/itemIcons/39d0a.png",
	"./39d12.png": "./src/assets/itemIcons/39d12.png",
	"./39e52.png": "./src/assets/itemIcons/39e52.png",
	"./39e53.png": "./src/assets/itemIcons/39e53.png",
	"./39e54.png": "./src/assets/itemIcons/39e54.png",
	"./39e55.png": "./src/assets/itemIcons/39e55.png",
	"./3a5a4.png": "./src/assets/itemIcons/3a5a4.png",
	"./3ac2e.png": "./src/assets/itemIcons/3ac2e.png",
	"./3ac2f.png": "./src/assets/itemIcons/3ac2f.png",
	"./3ac30.png": "./src/assets/itemIcons/3ac30.png",
	"./3ac31.png": "./src/assets/itemIcons/3ac31.png",
	"./3b97c.png": "./src/assets/itemIcons/3b97c.png",
	"./3eadd.png": "./src/assets/itemIcons/3eadd.png",
	"./3eade.png": "./src/assets/itemIcons/3eade.png",
	"./3eadf.png": "./src/assets/itemIcons/3eadf.png",
	"./3eae0.png": "./src/assets/itemIcons/3eae0.png",
	"./3eae1.png": "./src/assets/itemIcons/3eae1.png",
	"./3eae2.png": "./src/assets/itemIcons/3eae2.png",
	"./3eae3.png": "./src/assets/itemIcons/3eae3.png",
	"./3eae4.png": "./src/assets/itemIcons/3eae4.png",
	"./3eae5.png": "./src/assets/itemIcons/3eae5.png",
	"./3eae6.png": "./src/assets/itemIcons/3eae6.png",
	"./3eae7.png": "./src/assets/itemIcons/3eae7.png",
	"./3eae8.png": "./src/assets/itemIcons/3eae8.png",
	"./3eae9.png": "./src/assets/itemIcons/3eae9.png",
	"./3eaed.png": "./src/assets/itemIcons/3eaed.png",
	"./3eaee.png": "./src/assets/itemIcons/3eaee.png",
	"./3eaef.png": "./src/assets/itemIcons/3eaef.png",
	"./3eaf0.png": "./src/assets/itemIcons/3eaf0.png",
	"./3eaf1.png": "./src/assets/itemIcons/3eaf1.png",
	"./3eaf2.png": "./src/assets/itemIcons/3eaf2.png",
	"./3eaf4.png": "./src/assets/itemIcons/3eaf4.png",
	"./3eaf5.png": "./src/assets/itemIcons/3eaf5.png",
	"./3eaf6.png": "./src/assets/itemIcons/3eaf6.png",
	"./3eaf7.png": "./src/assets/itemIcons/3eaf7.png",
	"./3eafa.png": "./src/assets/itemIcons/3eafa.png",
	"./3eafb.png": "./src/assets/itemIcons/3eafb.png",
	"./3eafc.png": "./src/assets/itemIcons/3eafc.png",
	"./3eafd.png": "./src/assets/itemIcons/3eafd.png",
	"./3eafe.png": "./src/assets/itemIcons/3eafe.png",
	"./3eaff.png": "./src/assets/itemIcons/3eaff.png",
	"./3eb00.png": "./src/assets/itemIcons/3eb00.png",
	"./3eb02.png": "./src/assets/itemIcons/3eb02.png",
	"./3eb03.png": "./src/assets/itemIcons/3eb03.png",
	"./3eb04.png": "./src/assets/itemIcons/3eb04.png",
	"./3eb05.png": "./src/assets/itemIcons/3eb05.png",
	"./3eb09.png": "./src/assets/itemIcons/3eb09.png",
	"./3eb0a.png": "./src/assets/itemIcons/3eb0a.png",
	"./3eb0b.png": "./src/assets/itemIcons/3eb0b.png",
	"./3eb0c.png": "./src/assets/itemIcons/3eb0c.png",
	"./3eb0d.png": "./src/assets/itemIcons/3eb0d.png",
	"./3eb0e.png": "./src/assets/itemIcons/3eb0e.png",
	"./3eb0f.png": "./src/assets/itemIcons/3eb0f.png",
	"./3eb10.png": "./src/assets/itemIcons/3eb10.png",
	"./3eb11.png": "./src/assets/itemIcons/3eb11.png",
	"./3eb12.png": "./src/assets/itemIcons/3eb12.png",
	"./3eb14.png": "./src/assets/itemIcons/3eb14.png",
	"./3eb2a.png": "./src/assets/itemIcons/3eb2a.png",
	"./3eb2b.png": "./src/assets/itemIcons/3eb2b.png",
	"./3eb2c.png": "./src/assets/itemIcons/3eb2c.png",
	"./3eb2e.png": "./src/assets/itemIcons/3eb2e.png",
	"./3eb2f.png": "./src/assets/itemIcons/3eb2f.png",
	"./3eb30.png": "./src/assets/itemIcons/3eb30.png",
	"./3eb31.png": "./src/assets/itemIcons/3eb31.png",
	"./3eb32.png": "./src/assets/itemIcons/3eb32.png",
	"./3eb33.png": "./src/assets/itemIcons/3eb33.png",
	"./3eb35.png": "./src/assets/itemIcons/3eb35.png",
	"./3eb36.png": "./src/assets/itemIcons/3eb36.png",
	"./3eb37.png": "./src/assets/itemIcons/3eb37.png",
	"./3eb38.png": "./src/assets/itemIcons/3eb38.png",
	"./3eb39.png": "./src/assets/itemIcons/3eb39.png",
	"./3eb3a.png": "./src/assets/itemIcons/3eb3a.png",
	"./3eb3e.png": "./src/assets/itemIcons/3eb3e.png",
	"./3eb3f.png": "./src/assets/itemIcons/3eb3f.png",
	"./3eb40.png": "./src/assets/itemIcons/3eb40.png",
	"./3eb41.png": "./src/assets/itemIcons/3eb41.png",
	"./3f4bd.png": "./src/assets/itemIcons/3f4bd.png",
	"./5566a.png": "./src/assets/itemIcons/5566a.png",
	"./56a9d.png": "./src/assets/itemIcons/56a9d.png",
	"./56a9e.png": "./src/assets/itemIcons/56a9e.png",
	"./56b17.png": "./src/assets/itemIcons/56b17.png",
	"./57a7a.png": "./src/assets/itemIcons/57a7a.png",
	"./57a7b.png": "./src/assets/itemIcons/57a7b.png",
	"./58cfb.png": "./src/assets/itemIcons/58cfb.png",
	"./5ace3.png": "./src/assets/itemIcons/5ace3.png",
	"./5ace5.png": "./src/assets/itemIcons/5ace5.png",
	"./5ad93.png": "./src/assets/itemIcons/5ad93.png",
	"./5ad99.png": "./src/assets/itemIcons/5ad99.png",
	"./5ad9d.png": "./src/assets/itemIcons/5ad9d.png",
	"./5ad9e.png": "./src/assets/itemIcons/5ad9e.png",
	"./5ad9f.png": "./src/assets/itemIcons/5ad9f.png",
	"./5ada0.png": "./src/assets/itemIcons/5ada0.png",
	"./5ada1.png": "./src/assets/itemIcons/5ada1.png",
	"./65a65.png": "./src/assets/itemIcons/65a65.png",
	"./65a66.png": "./src/assets/itemIcons/65a66.png",
	"./65a68.png": "./src/assets/itemIcons/65a68.png",
	"./65a69.png": "./src/assets/itemIcons/65a69.png",
	"./65a6a.png": "./src/assets/itemIcons/65a6a.png",
	"./65a6b.png": "./src/assets/itemIcons/65a6b.png",
	"./65a6c.png": "./src/assets/itemIcons/65a6c.png",
	"./65a6d.png": "./src/assets/itemIcons/65a6d.png",
	"./65a6e.png": "./src/assets/itemIcons/65a6e.png",
	"./65a6f.png": "./src/assets/itemIcons/65a6f.png",
	"./65a70.png": "./src/assets/itemIcons/65a70.png",
	"./65a71.png": "./src/assets/itemIcons/65a71.png",
	"./68c63.png": "./src/assets/itemIcons/68c63.png",
	"./68c79.png": "./src/assets/itemIcons/68c79.png",
	"./68c7b.png": "./src/assets/itemIcons/68c7b.png",
	"./73f31.png": "./src/assets/itemIcons/73f31.png",
	"./73f32.png": "./src/assets/itemIcons/73f32.png",
	"./73f33.png": "./src/assets/itemIcons/73f33.png",
	"./73f34.png": "./src/assets/itemIcons/73f34.png",
	"./73f35.png": "./src/assets/itemIcons/73f35.png",
	"./73f36.png": "./src/assets/itemIcons/73f36.png",
	"./73f37.png": "./src/assets/itemIcons/73f37.png",
	"./73f38.png": "./src/assets/itemIcons/73f38.png",
	"./73f39.png": "./src/assets/itemIcons/73f39.png",
	"./73f3a.png": "./src/assets/itemIcons/73f3a.png",
	"./73f3b.png": "./src/assets/itemIcons/73f3b.png",
	"./73f3c.png": "./src/assets/itemIcons/73f3c.png",
	"./73f3d.png": "./src/assets/itemIcons/73f3d.png",
	"./73f3e.png": "./src/assets/itemIcons/73f3e.png",
	"./73f3f.png": "./src/assets/itemIcons/73f3f.png",
	"./73f40.png": "./src/assets/itemIcons/73f40.png",
	"./73f41.png": "./src/assets/itemIcons/73f41.png",
	"./73f42.png": "./src/assets/itemIcons/73f42.png",
	"./73f43.png": "./src/assets/itemIcons/73f43.png",
	"./73f44.png": "./src/assets/itemIcons/73f44.png",
	"./73f45.png": "./src/assets/itemIcons/73f45.png",
	"./73f46.png": "./src/assets/itemIcons/73f46.png",
	"./73f47.png": "./src/assets/itemIcons/73f47.png",
	"./73f48.png": "./src/assets/itemIcons/73f48.png",
	"./73f49.png": "./src/assets/itemIcons/73f49.png",
	"./73f4a.png": "./src/assets/itemIcons/73f4a.png",
	"./73f4b.png": "./src/assets/itemIcons/73f4b.png",
	"./73f4c.png": "./src/assets/itemIcons/73f4c.png",
	"./73f4d.png": "./src/assets/itemIcons/73f4d.png",
	"./73f4e.png": "./src/assets/itemIcons/73f4e.png",
	"./73f4f.png": "./src/assets/itemIcons/73f4f.png",
	"./73f50.png": "./src/assets/itemIcons/73f50.png",
	"./73f52.png": "./src/assets/itemIcons/73f52.png",
	"./73f53.png": "./src/assets/itemIcons/73f53.png",
	"./73f54.png": "./src/assets/itemIcons/73f54.png",
	"./73f55.png": "./src/assets/itemIcons/73f55.png",
	"./73f56.png": "./src/assets/itemIcons/73f56.png",
	"./73f57.png": "./src/assets/itemIcons/73f57.png",
	"./73f58.png": "./src/assets/itemIcons/73f58.png",
	"./73f59.png": "./src/assets/itemIcons/73f59.png",
	"./73f5a.png": "./src/assets/itemIcons/73f5a.png",
	"./73f5b.png": "./src/assets/itemIcons/73f5b.png",
	"./73f5c.png": "./src/assets/itemIcons/73f5c.png",
	"./73f5d.png": "./src/assets/itemIcons/73f5d.png",
	"./73f5e.png": "./src/assets/itemIcons/73f5e.png",
	"./73f5f.png": "./src/assets/itemIcons/73f5f.png",
	"./73f60.png": "./src/assets/itemIcons/73f60.png",
	"./73f61.png": "./src/assets/itemIcons/73f61.png",
	"./73f8b.png": "./src/assets/itemIcons/73f8b.png",
	"./73f8c.png": "./src/assets/itemIcons/73f8c.png",
	"./73f8d.png": "./src/assets/itemIcons/73f8d.png",
	"./73f8e.png": "./src/assets/itemIcons/73f8e.png",
	"./73f90.png": "./src/assets/itemIcons/73f90.png",
	"./73f91.png": "./src/assets/itemIcons/73f91.png",
	"./73f92.png": "./src/assets/itemIcons/73f92.png",
	"./73f93.png": "./src/assets/itemIcons/73f93.png",
	"./73f94.png": "./src/assets/itemIcons/73f94.png",
	"./74a38.png": "./src/assets/itemIcons/74a38.png",
	"./74a39.png": "./src/assets/itemIcons/74a39.png",
	"./74a3a.png": "./src/assets/itemIcons/74a3a.png",
	"./74a3b.png": "./src/assets/itemIcons/74a3b.png",
	"./800_AltherysEquipmentTiers_esp.png": "./src/assets/itemIcons/800_AltherysEquipmentTiers_esp.png",
	"./801_AltherysEquipmentTiers_esp.png": "./src/assets/itemIcons/801_AltherysEquipmentTiers_esp.png",
	"./801_Dawnguard_esm.png": "./src/assets/itemIcons/801_Dawnguard_esm.png",
	"./877a7.png": "./src/assets/itemIcons/877a7.png",
	"./877ab.png": "./src/assets/itemIcons/877ab.png",
	"./877b1.png": "./src/assets/itemIcons/877b1.png",
	"./877c9.png": "./src/assets/itemIcons/877c9.png",
	"./877ca.png": "./src/assets/itemIcons/877ca.png",
	"./877cb.png": "./src/assets/itemIcons/877cb.png",
	"./87834.png": "./src/assets/itemIcons/87834.png",
	"./896a3.png": "./src/assets/itemIcons/896a3.png",
	"./9171b.png": "./src/assets/itemIcons/9171b.png",
	"./a3115.png": "./src/assets/itemIcons/a3115.png",
	"./a9661.png": "./src/assets/itemIcons/a9661.png",
	"./ae723.png": "./src/assets/itemIcons/ae723.png",
	"./armor_amuletsandrings_goldamuletdiamondgo_nif_07737b33.png": "./src/assets/itemIcons/armor_amuletsandrings_goldamuletdiamondgo_nif_07737b33.png",
	"./armor_amuletsandrings_goldamuletgemsgo_nif_d6cec450.png": "./src/assets/itemIcons/armor_amuletsandrings_goldamuletgemsgo_nif_d6cec450.png",
	"./armor_amuletsandrings_goldamuletgo_nif_915dfd46.png": "./src/assets/itemIcons/armor_amuletsandrings_goldamuletgo_nif_915dfd46.png",
	"./armor_amuletsandrings_goldamuletrubygo_nif_2ad04803.png": "./src/assets/itemIcons/armor_amuletsandrings_goldamuletrubygo_nif_2ad04803.png",
	"./armor_amuletsandrings_silveramuletemeraldgo_nif_87b223a3.png": "./src/assets/itemIcons/armor_amuletsandrings_silveramuletemeraldgo_nif_87b223a3.png",
	"./armor_amuletsandrings_silveramuletsapphirego_nif_3094a55a.png": "./src/assets/itemIcons/armor_amuletsandrings_silveramuletsapphirego_nif_3094a55a.png",
	"./armor_elven_m_bootsgnd_nif_f498ecb3.png": "./src/assets/itemIcons/armor_elven_m_bootsgnd_nif_f498ecb3.png",
	"./armor_elven_m_cuirassheavygnd_nif_5eb2707f.png": "./src/assets/itemIcons/armor_elven_m_cuirassheavygnd_nif_5eb2707f.png",
	"./armor_elven_m_gauntletsgnd_nif_06a57417.png": "./src/assets/itemIcons/armor_elven_m_gauntletsgnd_nif_06a57417.png",
	"./armor_elven_m_helmetgnd_nif_24239b21.png": "./src/assets/itemIcons/armor_elven_m_helmetgnd_nif_24239b21.png",
	"./armor_glass_m_helmetglassgo_nif_85dbf760.png": "./src/assets/itemIcons/armor_glass_m_helmetglassgo_nif_85dbf760.png",
	"./armor_hide_m_cuirassheavygnd_nif_f955283f.png": "./src/assets/itemIcons/armor_hide_m_cuirassheavygnd_nif_f955283f.png",
	"./armor_hide_m_cuirasslightgnd_nif_2c3fb3e5.png": "./src/assets/itemIcons/armor_hide_m_cuirasslightgnd_nif_2c3fb3e5.png",
	"./armor_hide_m_helmetheavygnd_nif_8c1c3e45.png": "./src/assets/itemIcons/armor_hide_m_helmetheavygnd_nif_8c1c3e45.png",
	"./armor_hide_m_helmetlightgnd_nif_3ffc33e9.png": "./src/assets/itemIcons/armor_hide_m_helmetlightgnd_nif_3ffc33e9.png",
	"./armor_imperial_m_bootsgnd_nif_8fb03773.png": "./src/assets/itemIcons/armor_imperial_m_bootsgnd_nif_8fb03773.png",
	"./armor_imperial_m_cuirassgnd_nif_549e44aa.png": "./src/assets/itemIcons/armor_imperial_m_cuirassgnd_nif_549e44aa.png",
	"./armor_imperial_m_gauntletsgnd_nif_2f1e6f84.png": "./src/assets/itemIcons/armor_imperial_m_gauntletsgnd_nif_2f1e6f84.png",
	"./armor_imperial_m_helmetmediumgnd_nif_513fdf65.png": "./src/assets/itemIcons/armor_imperial_m_helmetmediumgnd_nif_513fdf65.png",
	"./armor_iron_male_bootsgnd_nif_2ec343ed.png": "./src/assets/itemIcons/armor_iron_male_bootsgnd_nif_2ec343ed.png",
	"./armor_iron_male_gauntletsgnd_nif_fcdc807b.png": "./src/assets/itemIcons/armor_iron_male_gauntletsgnd_nif_fcdc807b.png",
	"./armor_iron_male_helmetgnd_nif_0861d900.png": "./src/assets/itemIcons/armor_iron_male_helmetgnd_nif_0861d900.png",
	"./armor_iron_shield_nif_c007c12c.png": "./src/assets/itemIcons/armor_iron_shield_nif_c007c12c.png",
	"./armor_nordplate_boots_go_nif_c643f7cb.png": "./src/assets/itemIcons/armor_nordplate_boots_go_nif_c643f7cb.png",
	"./armor_nordplate_helmet_go_nif_e5b1ed28.png": "./src/assets/itemIcons/armor_nordplate_helmet_go_nif_e5b1ed28.png",
	"./armor_orcish_helmetgo_nif_9e63887c.png": "./src/assets/itemIcons/armor_orcish_helmetgo_nif_9e63887c.png",
	"./armor_studded_male_boots_go_nif_e9bda675.png": "./src/assets/itemIcons/armor_studded_male_boots_go_nif_e9bda675.png",
	"./armor_studded_male_helmet_go_nif_d4c3cc0b.png": "./src/assets/itemIcons/armor_studded_male_helmet_go_nif_d4c3cc0b.png",
	"./b647_Dawnguard_esm.png": "./src/assets/itemIcons/b647_Dawnguard_esm.png",
	"./bb3_Dawnguard_esm.png": "./src/assets/itemIcons/bb3_Dawnguard_esm.png",
	"./cd883.png": "./src/assets/itemIcons/cd883.png",
	"./d099_Dawnguard_esm.png": "./src/assets/itemIcons/d099_Dawnguard_esm.png",
	"./db5d2.png": "./src/assets/itemIcons/db5d2.png",
	"./dlc01_armor_dlc1hawkamuletgo_nif_9ca091fc.png": "./src/assets/itemIcons/dlc01_armor_dlc1hawkamuletgo_nif_9ca091fc.png",
	"./dlc01_armor_falmerheavy_shellbughelmetgo_nif_e058f27e.png": "./src/assets/itemIcons/dlc01_armor_falmerheavy_shellbughelmetgo_nif_e058f27e.png",
	"./dlc02_armor_bonemold_bonemoldshield_nif_92090c42.png": "./src/assets/itemIcons/dlc02_armor_bonemold_bonemoldshield_nif_92090c42.png",
	"./dlc02_armor_bonemold_bootsgnd_nif_b6d76bd2.png": "./src/assets/itemIcons/dlc02_armor_bonemold_bootsgnd_nif_b6d76bd2.png",
	"./dlc02_armor_bonemold_cuirassmediumgnd_nif_1c5c07b6.png": "./src/assets/itemIcons/dlc02_armor_bonemold_cuirassmediumgnd_nif_1c5c07b6.png",
	"./dlc02_armor_bonemold_gauntletsgnd_nif_600d0098.png": "./src/assets/itemIcons/dlc02_armor_bonemold_gauntletsgnd_nif_600d0098.png",
	"./dlc02_armor_bonemold_helmetgnd_nif_31ececbe.png": "./src/assets/itemIcons/dlc02_armor_bonemold_helmetgnd_nif_31ececbe.png",
	"./dlc02_armor_chitinheavy_bootsgnd_nif_43dcad1e.png": "./src/assets/itemIcons/dlc02_armor_chitinheavy_bootsgnd_nif_43dcad1e.png",
	"./dlc02_armor_chitinheavy_gauntletsgnd_nif_7b1a9134.png": "./src/assets/itemIcons/dlc02_armor_chitinheavy_gauntletsgnd_nif_7b1a9134.png",
	"./dlc02_armor_chitinheavy_helmetgnd_nif_8b20ca75.png": "./src/assets/itemIcons/dlc02_armor_chitinheavy_helmetgnd_nif_8b20ca75.png",
	"./dlc02_armor_chitinlight_bootsgnd_nif_c46699d6.png": "./src/assets/itemIcons/dlc02_armor_chitinlight_bootsgnd_nif_c46699d6.png",
	"./dlc02_armor_chitinlight_cuirassgnd_nif_b31a84d3.png": "./src/assets/itemIcons/dlc02_armor_chitinlight_cuirassgnd_nif_b31a84d3.png",
	"./dlc02_armor_chitinlight_gauntletsgnd_nif_cb0f8c91.png": "./src/assets/itemIcons/dlc02_armor_chitinlight_gauntletsgnd_nif_cb0f8c91.png",
	"./dlc02_armor_chitinlight_helmetgnd_nif_cde621d8.png": "./src/assets/itemIcons/dlc02_armor_chitinlight_helmetgnd_nif_cde621d8.png",
	"./dlc02_armor_nordiccarved_nordiccarvedbootsm_gnd_nif_1c5b91f9.png": "./src/assets/itemIcons/dlc02_armor_nordiccarved_nordiccarvedbootsm_gnd_nif_1c5b91f9.png",
	"./dlc02_armor_nordiccarved_nordiccarvedglovesm_gnd_nif_23133a09.png": "./src/assets/itemIcons/dlc02_armor_nordiccarved_nordiccarvedglovesm_gnd_nif_23133a09.png",
	"./dlc02_armor_nordiccarved_nordiccarvedhelmetm_gnd_nif_a1f5775c.png": "./src/assets/itemIcons/dlc02_armor_nordiccarved_nordiccarvedhelmetm_gnd_nif_a1f5775c.png",
	"./e2d3d.png": "./src/assets/itemIcons/e2d3d.png",
	"./eba01.png": "./src/assets/itemIcons/eba01.png",
	"./f19e_Dawnguard_esm.png": "./src/assets/itemIcons/f19e_Dawnguard_esm.png",
	"./f19f_Dawnguard_esm.png": "./src/assets/itemIcons/f19f_Dawnguard_esm.png",
	"./f1a0_Dawnguard_esm.png": "./src/assets/itemIcons/f1a0_Dawnguard_esm.png",
	"./f1b1_Dawnguard_esm.png": "./src/assets/itemIcons/f1b1_Dawnguard_esm.png",
	"./f1b7_Dawnguard_esm.png": "./src/assets/itemIcons/f1b7_Dawnguard_esm.png",
	"./f1b9_Dawnguard_esm.png": "./src/assets/itemIcons/f1b9_Dawnguard_esm.png",
	"./f1bb_Dawnguard_esm.png": "./src/assets/itemIcons/f1bb_Dawnguard_esm.png",
	"./f1bc_Dawnguard_esm.png": "./src/assets/itemIcons/f1bc_Dawnguard_esm.png",
	"./f4314.png": "./src/assets/itemIcons/f4314.png",
	"./f4315.png": "./src/assets/itemIcons/f4315.png",
	"./f431b.png": "./src/assets/itemIcons/f431b.png",
	"./f431c.png": "./src/assets/itemIcons/f431c.png",
	"./f431d.png": "./src/assets/itemIcons/f431d.png",
	"./f431e.png": "./src/assets/itemIcons/f431e.png",
	"./f4320.png": "./src/assets/itemIcons/f4320.png",
	"./f6f22.png": "./src/assets/itemIcons/f6f22.png",
	"./f6f24.png": "./src/assets/itemIcons/f6f24.png",
	"./f9642.png": "./src/assets/itemIcons/f9642.png",
	"./ff9fc.png": "./src/assets/itemIcons/ff9fc.png",
	"./ff9fd.png": "./src/assets/itemIcons/ff9fd.png",
	"./ff9fe.png": "./src/assets/itemIcons/ff9fe.png",
	"./ff9ff.png": "./src/assets/itemIcons/ff9ff.png",
	"./ffa00.png": "./src/assets/itemIcons/ffa00.png",
	"./ffa01.png": "./src/assets/itemIcons/ffa01.png",
	"./ffa02.png": "./src/assets/itemIcons/ffa02.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/itemIcons sync \\.png$";